module.exports = __webpack_public_path__ + "static/forecast/weather/dayheavysnow-21c29da85be91fb938b6051f8da2d0c1.svg";